import { render, staticRenderFns } from "./BusinessPlanTour.vue?vue&type=template&id=0a351bdb"
import script from "./BusinessPlanTour.vue?vue&type=script&lang=js"
export * from "./BusinessPlanTour.vue?vue&type=script&lang=js"
import style0 from "./BusinessPlanTour.vue?vue&type=style&index=0&id=0a351bdb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports